import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export async function createLead(payload) {
  const { data } = await axios.post(`${API}/leads`, payload);
  return data;
}

export async function getLeadCount() {
  const { data } = await axios.get(`${API}/leads/count`);
  return data?.count ?? 0;
}

export async function listLeads(limit = 50) {
  const { data } = await axios.get(`${API}/leads`, { params: { limit } });
  return Array.isArray(data) ? data : [];
}

export async function clearAllLeads() {
  const { data } = await axios.delete(`${API}/leads`);
  return data;
}
